"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pollein": {
    "02985d33": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "0c026a01": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "15d73183": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": false,
      "skipSearch": false
    }],
    "2d1d45b9": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "3abf152e": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": false,
      "skipSearch": false
    }],
    "591cfc7b": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": false,
      "skipSearch": false
    }],
    "616352cb": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": false,
      "skipSearch": false
    }],
    "66d1dbcc": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "67476e24": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "74eaeca4": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "9e20d284": [{
      "hkey": "54d05ab6",
      "slug": "grand-pollein-petit-pollein",
      "name": "Grand Pollein-Petit Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "9e8bcbe1": [{
      "hkey": "54d05ab6",
      "slug": "grand-pollein-petit-pollein",
      "name": "Grand Pollein-Petit Pollein",
      "primary": false,
      "skipSearch": false
    }],
    "alte-localita-rongachet": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bcc4fde2": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": false,
      "skipSearch": false
    }],
    "capoluogo": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "capoluogo-chez-buillet": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf1b0093": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "chateau": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "chenaux": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pollein"
    }],
    "chenieres": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pollein"
    }],
    "cretes": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pollein"
    }],
    "d34fc1d9": [{
      "hkey": "135e661a",
      "slug": "tharencan",
      "name": "Tharencan",
      "primary": true,
      "skipSearch": false
    }],
    "d504f379": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "donanche": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "drejer": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pollein"
    }],
    "e10006d4": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "skipSearch": false
    }],
    "grand-place": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "grand-pollein": [{
      "hkey": "54d05ab6",
      "slug": "grand-pollein-petit-pollein",
      "name": "Grand Pollein-Petit Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "petit-pollein": [{
      "hkey": "54d05ab6",
      "slug": "grand-pollein-petit-pollein",
      "name": "Grand Pollein-Petit Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pollein"
    }],
    "rabloz": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "saint-benin": [{
      "hkey": "c77afaba",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pollein"
    }],
    "terreblanche": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "tharencan-localita-tharencan": [{
      "hkey": "135e661a",
      "slug": "tharencan",
      "name": "Tharencan",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "tissoniere": [{
      "hkey": "66ad3ca5",
      "slug": "pollein",
      "name": "Pollein",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;